import * as React from "react"
import { Skeleton, Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { WEBBACK_V2_API} from "@constants";
import {useToast} from "@hooks";
import { customerID } from "@signals"
import {
    daysOutStockColumn,
    daysStockColumn,
    firstSeenColumn,
    lastDayStockColumn,
    lastOutStockColumn,
    lastSeenColumn,
    skuColumn,
    retailerColumn,
    stockStatusColumn,
	assortmentColumn,
	streetDateColumn
} from "./columns"
import { useStockAssortmentNotListedSearch } from "./@hooks";
import { stockAssDetailsNotListedFilters } from "../@signals";


const HEIGHT = 500

export default function StockAssortmentNotListedTable() {

	const { dataNotListed, isLoadingNotListed, resetNotListedData } = useStockAssortmentNotListedSearch()
	const { showToast } = useToast()

	if (isLoadingNotListed) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!dataNotListed.length) return <></>

	const isAmazon = dataNotListed.some(row => row.retailer?.toLowerCase().includes('amazon'))
	const showStreetDate = isAmazon && customerID.value === 6

	return <Box id='not-listed-table'>
		<AppTableSeeker
			title={<TitleWithPopover title="Stock & Assortment - All Assortment" />}
			data={dataNotListed}
			columns={[
				...retailerColumn(),
				...skuColumn(),
				...firstSeenColumn(),
				...lastSeenColumn(),
				...stockStatusColumn(),
				...assortmentColumn(),
				...showStreetDate ? [...streetDateColumn()] : [],
				lastDayStockColumn(),
				daysStockColumn(),
				lastOutStockColumn(),
				daysOutStockColumn()
			]}
			options={{
				onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/stock-assortment/details/all-products-excel`, stockAssDetailsNotListedFilters.value),
				rowsPerPageOptions: [5, 10],
				customToolbar: () => <IconSeeker 
					icon={'circle-xmark'} 
					sx={{ mr: 0.5, margin: .5, fontSize: '1.5rem', color: 'text.disabled' }} 
					tooltip={'Close Not Listed Table'}
					onClick={resetNotListedData}
				/>
			}}
		/>
	</Box>
}